import {defineDynamicImport} from "../dynamicImport/defineDynamicImport.ts";
import * as MyopHelpers from "./index.ts";

export * from "./index.ts";

defineDynamicImport('MyopHelpers', MyopHelpers);
